import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const DEFAULT_MULTICOMPANY_ENABLED = false;

export interface MultiCompanyState {
  enabled: boolean;
}

const initialState: MultiCompanyState = {
  enabled: DEFAULT_MULTICOMPANY_ENABLED,
};

export const multiCompanyParamsSlice = createSlice({
  name: "multiCompanyParams",
  initialState,
  reducers: {
    setMultiCompanyEnabled: (state, action: PayloadAction<boolean>) => {
      state.enabled = action.payload;
    },
  },
});

export const { setMultiCompanyEnabled } =
  multiCompanyParamsSlice.actions;

export default multiCompanyParamsSlice.reducer;
